/* Barrel export mapping variant archetype IDs to their render functions. */

import type { KiwiPalette } from "../kiwiPalettes";
import type { VariantArchetype } from "@/types/kiwiSkin";
import { renderAstronaut } from "./renderAstronaut";
import { renderPirate } from "./renderPirate";
import { renderNinja } from "./renderNinja";
import { renderWizard } from "./renderWizard";
import { renderRobot } from "./renderRobot";
import { renderGhost } from "./renderGhost";
import { renderChef } from "./renderChef";
import { renderAngel } from "./renderAngel";
import { renderDevil } from "./renderDevil";
import { renderNerd } from "./renderNerd";
import { renderKnight } from "./renderKnight";
import { renderDJ } from "./renderDJ";
import { renderScholar } from "./renderScholar";
import { renderReader } from "./renderReader";
import { renderScientist } from "./renderScientist";
import { renderBrainy } from "./renderBrainy";

export type VariantRenderer = (palette: KiwiPalette) => React.ReactNode;

export const VARIANT_RENDERERS: Record<VariantArchetype, VariantRenderer> = {
  astronaut: renderAstronaut,
  pirate: renderPirate,
  ninja: renderNinja,
  wizard: renderWizard,
  robot: renderRobot,
  ghost: renderGhost,
  chef: renderChef,
  angel: renderAngel,
  devil: renderDevil,
  nerd: renderNerd,
  knight: renderKnight,
  dj: renderDJ,
  scholar: renderScholar,
  reader: renderReader,
  scientist: renderScientist,
  brainy: renderBrainy,
};
